import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

interface Props {
    listType: keyof typeof listTypes;
    elementProps: RenderElementProps;
}

export default function ListNode({listType, elementProps}: Props) {
    const {attributes, children} = elementProps;
    const {tag, listStyle} = listTypes[listType];

    return (
        <Body {...attributes} tag={tag} style={listStyle}>
            {children}
        </Body>
    );
}

const styles = StyleSheet.create({
    bulleted: {
        listStyle: "disc",
        marginInlineStart: spacing.large_24,
        marginBlockEnd: spacing.medium_16,
    },
    numbered: {
        listStyle: "decimal",
        marginInlineStart: spacing.large_24,
        marginBlockEnd: spacing.medium_16,
    },
    lettered: {
        listStyle: "lower-alpha",
        marginInlineStart: spacing.large_24,
        marginBlockEnd: spacing.medium_16,
    },
});

const listTypes = {
    "bulleted-list": {
        tag: "ul",
        listStyle: styles.bulleted,
    },
    "numbered-list": {
        tag: "ol",
        listStyle: styles.numbered,
    },
    "lettered-list": {
        tag: "ol",
        listStyle: styles.lettered,
    },
};
